import { Filters } from '../pageConfig/Types';
import { AnalyticTrackingBasePropertiesObj } from './model/AnalyticTrackingBasePropertiesObj';
import { OpaSubscription } from '@models/Opa';
import { isAuthorized } from '../Permission';
import { access } from '@const/Access';

export const doAmplitudeAnalyticsTracking = (
  eventTitle: string,
  track: (event: string, properties?: Object) => void,
  trackingProperties: AnalyticTrackingBasePropertiesObj,
): void => {
  track(eventTitle, trackingProperties);
};

export const concatenateSelectedFeatureName = (selectedFeatures: Filters | undefined) => {
  if (!selectedFeatures?.options.length) return 'ALL';
  return selectedFeatures.options
    .map((feature) => {
      return feature.label;
    })
    .join(', ');
};

export const concatenateAllSelectedSegmentFeatureName = (allSelectedSegmentFeatures: Filters[] | undefined) => {
  if (!allSelectedSegmentFeatures?.length) return undefined;

  return allSelectedSegmentFeatures
    ?.flatMap((filter) => {
      return filter.options.map((feature) => {
        return feature.value;
      });
    })
    .join(', ');
};

export const constructAccessObject = (
  clientSubscription: OpaSubscription,
  hitlistsClientSubscription: OpaSubscription,
  retailKadClientSubscription: OpaSubscription,
  marketPremiumClientSubscription: OpaSubscription,
  sellerInsightsClientSubscription: OpaSubscription,
) => {
  let accessList = [];
  if (isAuthorized(clientSubscription)) {
    accessList.push(access.RetailInsights);
  }
  if (isAuthorized(hitlistsClientSubscription)) {
    accessList.push(access.Hitlists);
  }
  if (isAuthorized(retailKadClientSubscription)) {
    accessList.push(access.KeyAccount);
  }
  if (isAuthorized(marketPremiumClientSubscription)) {
    accessList.push(access.MarketPremium);
  }
  if (isAuthorized(sellerInsightsClientSubscription)) {
    accessList.push(access.SellerInsights);
  }
  return accessList;
};
